type ChainHandler<T> = (text: string, result: HandlerResult<T>) => HandlerResult<T>;

export interface HandlerResult<T> {
  data: T;
  done?: boolean;
}

export class PasteToQueryBaseHelper<T> {
  constructor(private readonly chainHandlers: ChainHandler<T>[]) {}

  public getDataFromText(text: string): T {
    return this.chainHandlers.reduce(
      (result, handler) => {
        if (!result.done) {
          return handler(text, result);
        }

        return result;
      },
      {
        data: {}
      } as HandlerResult<T>
    ).data;
  }
}
